/**
 * External dependencies
 */
import { combineReducers } from 'redux';

/**
 * Reducers
 */
import application from './application/reducer';
import currentUser from './current-user/reducer';
import documentHead from './document-head/reducer';
import login from './login/reducer';
import notices from './notices/reducer';
import preferences from './preferences/reducer';
import ui from './ui/reducer';
import graphCube from './graph-cube/reducer';
import dashboardLayouts from './dashboard-layouts/reducer';
import dashboard from './dashboard/reducer';
import importOperation from './import-operation/reducer';
import startup from './startup/reducer';
import reports from './reports/reducer';


// Please keep this list alphabetized!
const reducers = {
    application,
    currentUser,
    dashboard,
    dashboardLayouts,
    documentHead,
    graphCube,
    importOperation,
    login,
    notices,
    startup,
    preferences,
    ui,
    reports
};

export default combineReducers(reducers);
